import { StripeModal } from "./StripeModal";

export default StripeModal;
